import * as fromAnalyticsActions from '../actions/analytics.actions';
import {
  IAnalyticsState,
  initIAnalyticsState,
} from '../states/aumye-analytics.state';

export function reducer(
  state = initIAnalyticsState,
  action: fromAnalyticsActions.CyclopsAnalyticsActionUnion
): IAnalyticsState {
  switch (action.type) {
    case fromAnalyticsActions.AnalyticsActionTypes.RESET_STATE: {
      return initIAnalyticsState;
    }
    case fromAnalyticsActions.AnalyticsActionTypes.INIT_ANALYTICS_DATA: {
      let {
        payload: { visitorDetails, incidentDetails },
      } = action;
      return {
        ...state,
        visitorDetails: visitorDetails,
        incidentDetails: incidentDetails,
      };
    }
    case fromAnalyticsActions.AnalyticsActionTypes.GET_VISITOR_TICKET_SUCCESS: {
      let { payload } = action;
      return {
        ...state,
        visitorTickets: payload,
        status: {
          ...state.status,
          isVisitorAnalyticsDataLoaded: true,
        },
      };
    }
    case fromAnalyticsActions.AnalyticsActionTypes
      .GET_INCIDENT_TICKET_SUCCESS: {
        let { payload } = action;
        return {
          ...state,
          incidentTickets: payload,
          status: {
            ...state.status,
            isIncidentAnalyticsDataLoaded: true,
          },
        };
      }
    case fromAnalyticsActions.AnalyticsActionTypes
      .GET_COMPLAINTS_TICKET_SUCCESS: {
        let { payload } = action;
        return {
          ...state,
          complaintsTickets: payload,
          status: {
            ...state.status,
            isComplaintsDataLoaded: true,
          },
        };
      }
    case fromAnalyticsActions.AnalyticsActionTypes.GET_CLAIM_TICKET_SUCCESS: {
      let { payload } = action;
      return {
        ...state,
        claimsTickets: payload,
        status: {
          ...state.status,
          isClaimsDataLoaded: true,
        },
      };
    }
    case fromAnalyticsActions.AnalyticsActionTypes
      .GET_REQUESTS_TICKET_SUCCESS: {
        let { payload } = action;
        return {
          ...state,
          requestsTickets: payload,
          status: {
            ...state.status,
            isRequestsDataLoaded: true,
          },
        };
      }
    case fromAnalyticsActions.AnalyticsActionTypes.SAVE_RISK_PROFILE_SIM: {
      let { payload } = action;
      localStorage.setItem('IsQuestionsAnswered', 'true');
      localStorage.setItem('Risks', JSON.stringify(payload));
      return {
        ...state,
        riskQuestions: payload,
        status: {
          ...state.status,
          isRiskAnalyticsDataLoaded: true,
        },
      };
    }
    case fromAnalyticsActions.AnalyticsActionTypes.GET_RISK_PROFILE_SUCCESS: {
      let {
        payload: {
          riskAnalyticsGraph,
          riskData,
          riskSingleAnalyticsGraph,
          criticalIncidentsCounts,
          criticalIncidentsData,
          criticalIncidentsCountNumber,
          averageCloseTime,
          currentMonthRiskScore,
          previousMonthRiskScore,
          criticalRiskHour,
          heatMapData,
          riskAnalyticsStatusGraph,
          totalClaimAmountCurrent,
          totalClaimAmountPrevious,
          previousMonthClaimData,
          currentMonthClaimData,
          riskAnalyticsPreviousMonthGraph,
          incidentAnalytics,
          visitorAnalytics,
          assetAnalytics,
          bookingAnalytics,
          eventAnalytics,
          animalAnalytics
        },
      } = action;
      return {
        ...state,
        riskQuestions: riskData,
        riskAnalyticsGraph: riskAnalyticsGraph,
        riskAnalyticsPreviousMonthGraph: riskAnalyticsPreviousMonthGraph,
        riskSingleAnalyticsGraph: riskSingleAnalyticsGraph,
        averageCloseTime: averageCloseTime,
        criticalIncidentsCounts: criticalIncidentsCounts,
        criticalIncidentsData: criticalIncidentsData,
        criticalIncidentsCountNumber: criticalIncidentsCountNumber,
        currentMonthRiskScore: currentMonthRiskScore,
        previousMonthRiskScore: previousMonthRiskScore,
        criticalRiskHour: criticalRiskHour,
        riskHeatMapData: heatMapData,
        riskAnalyticsStatusGraph: riskAnalyticsStatusGraph,
        currentMonthClaimTotal: currentMonthClaimData,
        previousMonthClaimTotal: previousMonthClaimData,
        currentMonthClaimAmount: totalClaimAmountCurrent,
        previousMonthClaimAmount: totalClaimAmountPrevious,
        incidentAnalytics: incidentAnalytics,
        visitorAnalytics: visitorAnalytics,
        assetAnalytics: assetAnalytics,
        bookingAnalytics: bookingAnalytics,
        eventAnalytics: eventAnalytics,
        animalAnalytics: animalAnalytics,
        status: {
          ...state.status,
          isRiskAnalyticsDataLoaded: true,
        },
      };
    }
    case fromAnalyticsActions.AnalyticsActionTypes
      .GET_VISITOR_ANALYTICS_SUCCESS: {
        let {
          payload: {
            monthlyVisitorBarGraph,
            monthlyVisitorInOutGraph,
            monthlyVisitorCategory,
            uniqueVisitors,
            currentDayVisitors,
            hotCheckInSlot,
          },
        } = action;
        return {
          ...state,
          monthlyVisitorBarGraph: monthlyVisitorBarGraph,
          monthlyVisitorInOutGraph: monthlyVisitorInOutGraph,
          monthlyVisitorCategory: monthlyVisitorCategory,
          uniqueVisitors: uniqueVisitors,
          currentDayVisitors: currentDayVisitors,
          hotCheckInSlot: hotCheckInSlot,
        };
      }
    case fromAnalyticsActions.AnalyticsActionTypes
      .GET_RISK_PROFILE_SUCCESS_NEW: {
        let {
          payload: {
            categoryRiskTrends,
            overallRiskScore,
            overallRiskTrend,
            overallRiskChangePercentage,
            categorizedIncidents,
            categorizedRiskScore,
            processedIncidents,
            totalCount,
            overallRiskScoresByDateRange
          },
        } = action;
        return {
          ...state,
          categoryRiskTrends: categoryRiskTrends,
          overallRiskScore,
          overallRiskTrend,
          overallRiskChangePercentage,
          categorizedIncidents,
          categorizedRiskScore,
          processedIncidents,
          totalCount,
          overallRiskScoresByDateRange
        };
      }
  }
  return state;
}
